var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info.content)?_c('div',{staticClass:"active-info"},[_c('div',{staticClass:"content ql-editor",domProps:{"innerHTML":_vm._s(_vm.info.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }